enum ActionTypes {
	MarkTournamentLoaded = "App.MarkTournamentLoaded"
};

export default ActionTypes;